import { Mail, CalendarClock, ArrowUpRight, MessageCircle } from "lucide-react";
import { CONTACT, IMG } from "../data/site";
import { Reveal, Marker } from "./shared";
import { useI18n } from "../i18n/LanguageContext";

export const Contact = () => {
  const { t } = useI18n();
  const cc = t.contact;
  const cards = [
    { icon: MessageCircle, label: cc.whatsapp, value: CONTACT.whatsapp, href: CONTACT.whatsappHref, testid: "contact-whatsapp", accent: true, ext: true },
    { icon: Mail, label: cc.email, value: CONTACT.email, href: CONTACT.emailHref, testid: "contact-email", ext: false },
    { icon: CalendarClock, label: cc.consult, value: cc.bookCall, href: CONTACT.calendly, testid: "contact-calendly", ext: true },
  ];

  return (
    <section id="contact" className="py-20 sm:py-28" data-testid="contact-section">
      <div className="container-x">
        <div className="relative overflow-hidden rounded-[2rem] bg-navy px-6 py-16 sm:rounded-[2.75rem] sm:px-12 sm:py-20 lg:px-20">
          <div className="pointer-events-none absolute -left-20 -top-20 h-80 w-80 rounded-full bg-gold/20 blur-[120px]" />
          <div className="pointer-events-none absolute -bottom-24 right-0 h-80 w-80 rounded-full bg-navy-600/50 blur-[120px]" />

          <div className="relative max-w-3xl">
            <Reveal><span className="eyebrow">{cc.eyebrow}</span></Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.02] tracking-tight text-white sm:text-6xl">
                {cc.title} <Marker><span className="text-gold-300">{cc.accent}</span></Marker>
              </h2>
            </Reveal>
            <Reveal delay={0.16}><p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">{cc.sub}</p></Reveal>
          </div>

          <div className="relative mt-12 grid gap-4 sm:grid-cols-3">
            {cards.map((c, i) => {
              const Icon = c.icon;
              return (
                <Reveal key={c.label} delay={i * 0.08}>
                  <a href={c.href} {...(c.ext ? { target: "_blank", rel: "noreferrer" } : {})} data-testid={c.testid}
                    className={`group flex h-full flex-col justify-between rounded-3xl p-7 transition-transform duration-300 hover:-translate-y-1.5 ${c.accent ? "bg-gold" : "bg-white/5 ring-1 ring-white/10 hover:bg-white/10"}`}>
                    <div className="flex items-center justify-between">
                      <Icon size={26} className={c.accent ? "text-white" : "text-gold-300"} />
                      <ArrowUpRight size={20} className={c.accent ? "text-white/90" : "text-white/60"} />
                    </div>
                    <div className="mt-14">
                      <span className={`text-xs font-medium uppercase tracking-[0.16em] ${c.accent ? "text-white/80" : "text-white/50"}`}>{c.label}</span>
                      <p className="mt-1.5 break-words font-display text-xl font-semibold text-white">{c.value}</p>
                    </div>
                  </a>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
